import { render, staticRenderFns } from "./DeleteClientDoc.vue?vue&type=template&id=6cfc519a"
import script from "./DeleteClientDoc.vue?vue&type=script&lang=js"
export * from "./DeleteClientDoc.vue?vue&type=script&lang=js"
import style0 from "./DeleteClientDoc.vue?vue&type=style&index=0&id=6cfc519a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports